import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getEmailTemplate, saveEmailClient, saveEmailTemplate } from '../../../api/EmailTemplate/emailTemplate';
import { EmailTemplateInfo } from '../../../utility/listingEmail';

const KEY = [ 'emailTemplate' ];

export function useEmailTemplate() {
  const query = useQuery({ queryKey: KEY, queryFn: () => getEmailTemplate(), retry: false });
  return { template: (query.data?.data as EmailTemplateInfo) || null, isLoading: query.isLoading, error: query.error };
}

export function useSaveEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: string) => saveEmailTemplate(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useSaveEmailClient() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (emailClient: string) => saveEmailClient(emailClient),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEY });
      queryClient.invalidateQueries({ queryKey: [ 'listingEmails' ] });
    },
  });
}
